import * as events from '../base/constant';
import { isNullOrUndefined, Browser } from '@syncfusion/ej2-base';
import { Clipboard as GridClipboard } from '@syncfusion/ej2-grids';
/**
 * The `Clipboard` module is used to handle clipboard copy action.
 *
 * @hidden
 */
export class TreeClipboard extends GridClipboard {
    constructor(parent, serviceLocator) {
        super(parent.grid, serviceLocator);
        this.treeCopyContent = '';
        this.copiedUniqueIdCollection = [];
        this.treeGridParent = parent;
        this.serviceLocator = serviceLocator;
    }
    setCopyData(withHeader) {
        const copyContent = 'copyContent';
        const getCopyData = 'getCopyData';
        const isSelect = 'isSelect';
        const uniqueID = 'uniqueID';
        const currentRecords = this.treeGridParent.getCurrentViewRecords();
        if (window.getSelection().toString() === '') {
            this.clipBoardTextArea.value = this[`${copyContent}`] = '';
            const rows = this.treeGridParent.grid.getRows();
            if (this.treeGridParent.selectionSettings.mode !== 'Cell') {
                const selectedIndexes = this.treeGridParent.getSelectedRowIndexes().sort((a, b) => {
                    return a - b;
                });
                for (let i = 0; i < selectedIndexes.length; i++) {
                    if (i > 0) {
                        this.treeCopyContent += '\n';
                    }
                    const selectedRowIndex = selectedIndexes[parseInt(i.toString(), 10)];
                    if (!rows[selectedRowIndex].classList.contains('e-summaryrow')) {
                        const cells = [].slice.call(rows[selectedRowIndex].querySelectorAll('.e-rowcell'));
                        const uniqueid = this.treeGridParent.getSelectedRecords()[parseInt(i.toString(), 10)][`${uniqueID}`];
                        if (this.copiedUniqueIdCollection.indexOf(uniqueid) === -1) {
                            if (this.treeGridParent.copyHierarchyMode === 'Parent' || this.treeGridParent.copyHierarchyMode === 'Both') {
                                this.parentContentData(currentRecords, selectedRowIndex, rows, withHeader, i);
                            }
                            this[`${getCopyData}`](cells, false, '\t', withHeader);
                            this.treeCopyContent += this[`${copyContent}`];
                            this.copiedUniqueIdCollection.push(uniqueid);
                            this[`${copyContent}`] = '';
                            if (this.treeGridParent.copyHierarchyMode === 'Child' || this.treeGridParent.copyHierarchyMode === 'Both') {
                                this.childContentData(currentRecords, selectedIndexes[parseInt(i.toString(), 10)], rows, withHeader);
                            }
                        }
                    }
                }
                if (withHeader) {
                    const headerTextArray = this.treeGridParent.getVisibleColumns().map((col) => col.headerText);
                    this[`${getCopyData}`](headerTextArray, false, '\t', withHeader);
                    this.treeCopyContent = this[`${copyContent}`] + '\n' + this.treeCopyContent;
                }
                const args = {
                    data: this.treeCopyContent,
                    cancel: false
                };
                this.treeGridParent.trigger(events.beforeCopy, args);
                if (args.cancel) {
                    return;
                }
                this.clipBoardTextArea.value = this[`${copyContent}`] = args.data;
                if (!Browser.userAgent.match(/ipad|ipod|iphone/i)) {
                    this.clipBoardTextArea.select();
                }
                else {
                    this.clipBoardTextArea.setSelectionRange(0, this.clipBoardTextArea.value.length);
                }
                this[`${isSelect}`] = true;
                this.copiedUniqueIdCollection = [];
                this.treeCopyContent = '';
            }
            else {
                super.setCopyData(withHeader);
            }
        }
    }
    parentContentData(currentRecords, selectedIndex, rows, withHeader, index) {
        const getCopyData = 'getCopyData';
        const copyContent = 'copyContent';
        const parentItem = 'parentItem';
        const uniqueID = 'uniqueID';
        const level = 'level';
        if (!isNullOrUndefined(currentRecords[parseInt(selectedIndex.toString(), 10)][`${parentItem}`])) {
            const treeLevel = currentRecords[parseInt(selectedIndex.toString(), 10)][`${parentItem}`][`${level}`];
            for (let i = 0; i < treeLevel + 1; i++) {
                for (let j = 0; j < currentRecords.length; j++) {
                    if (!isNullOrUndefined(currentRecords[parseInt(selectedIndex.toString(), 10)][`${parentItem}`]) &&
                        currentRecords[parseInt(j.toString(), 10)][`${uniqueID}`] === currentRecords[parseInt(selectedIndex.toString(), 10)][`${parentItem}`][`${uniqueID}`]) {
                        selectedIndex = j;
                        const cells = [].slice.call(rows[parseInt(selectedIndex.toString(), 10)].querySelectorAll('.e-rowcell'));
                        const uniqueid = currentRecords[parseInt(j.toString(), 10)][`${uniqueID}`];
                        if (this.copiedUniqueIdCollection.indexOf(uniqueid) === -1) {
                            this[`${getCopyData}`](cells, false, '\t', withHeader);
                            if (index > 0) {
                                this.treeCopyContent = this.treeCopyContent + this[`${copyContent}`] + '\n';
                            }
                            else {
                                this.treeCopyContent = this[`${copyContent}`] + '\n' + this.treeCopyContent;
                            }
                            this.copiedUniqueIdCollection.push(uniqueid);
                            this[`${copyContent}`] = '';
                            break;
                        }
                    }
                }
            }
        }
    }
    copy(withHeader) {
        super.copy(withHeader);
    }
    paste(data, rowIndex, colIndex) {
        super.paste(data, rowIndex, colIndex);
    }
    /**
     * For internal use only - Get the module name.
     *
     * @private
     * @returns {string} Returns clipboard module name
     */
    getModuleName() {
        return 'clipboard';
    }
    /**
     * To destroy the clipboard
     *
     * @returns {void}
     * @hidden
     */
    destroy() {
        super.destroy();
    }
    childContentData(currentRecords, selectedIndex, rows, withHeader) {
        const getCopyData = 'getCopyData';
        const copyContent = 'copyContent';
        const childRecords = 'childRecords';
        const hasChildRecords = 'hasChildRecords';
        const uniqueID = 'uniqueID';
        if (currentRecords[parseInt(selectedIndex.toString(), 10)][`${hasChildRecords}`]) {
            const childData = currentRecords[parseInt(selectedIndex.toString(), 10)][`${childRecords}`];
            for (let i = 0; i < childData.length; i++) {
                for (let j = 0; j < currentRecords.length; j++) {
                    if (!isNullOrUndefined(childData[parseInt(i.toString(), 10)][`${uniqueID}`]) && currentRecords[parseInt(j.toString(), 10)][`${uniqueID}`] === childData[parseInt(i.toString(), 10)][`${uniqueID}`]) {
                        if ((!isNullOrUndefined(rows[parseInt(j.toString(), 10)])) && !rows[parseInt(j.toString(), 10)].classList.contains('e-summaryrow')) {
                            const cells = [].slice.call(rows[parseInt(j.toString(), 10)].querySelectorAll('.e-rowcell'));
                            const uniqueid = currentRecords[parseInt(j.toString(), 10)][`${uniqueID}`];
                            if (this.copiedUniqueIdCollection.indexOf(uniqueid) === -1) {
                                this[`${getCopyData}`](cells, false, '\t', withHeader);
                                this.treeCopyContent += ('\n' + this[`${copyContent}`]);
                                this[`${copyContent}`] = '';
                                this.copiedUniqueIdCollection.push(uniqueid);
                                this.childContentData(currentRecords, j, rows, withHeader);
                            }
                        }
                        break;
                    }
                }
            }
        }
    }
}
